var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVriLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.8 132.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#faaf40;}.cls-3{fill:#61449a;}.cls-4{font-size:23px;fill:#4d4d4f;font-family:OpenSans-Semibold, Open Sans;font-weight:600;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.61,
    y1: 4.97,
    x2: 48.61,
    y2: 88.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.63,
    width: 91.96,
    height: 91.96,
    rx: 19.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.28,17.21A13.26,13.26,0,0,1,64,23.29a16.88,16.88,0,0,1-3.41,3.89,19.28,19.28,0,0,1-2,1.44c-.2-.32-.44-.62-.67-.92-.1-.13-.2-.26-.29-.4s0-.1.07-.17l.32-.29a8.45,8.45,0,0,0,2.44-4.49,8.81,8.81,0,0,0,.11-.88c0-.08,0-.3,0-.3l-.36,0A5.19,5.19,0,0,1,57,19.57a5.29,5.29,0,0,1-1.22-2A5.15,5.15,0,0,1,55.57,15a5.3,5.3,0,0,1,6.08-4.37,5.8,5.8,0,0,1,4.62,5.39A7.5,7.5,0,0,1,66.28,17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.28,17.21A13.26,13.26,0,0,1,64,23.29a16.88,16.88,0,0,1-3.41,3.89,19.28,19.28,0,0,1-2,1.44c-.2-.32-.44-.62-.67-.92-.1-.13-.2-.26-.29-.4s0-.1.07-.17l.32-.29a8.45,8.45,0,0,0,2.44-4.49,8.81,8.81,0,0,0,.11-.88c0-.08,0-.3,0-.3l-.36,0A5.19,5.19,0,0,1,57,19.57a5.29,5.29,0,0,1-1.22-2A5.15,5.15,0,0,1,55.57,15a5.3,5.3,0,0,1,6.08-4.37,5.8,5.8,0,0,1,4.62,5.39A7.5,7.5,0,0,1,66.28,17.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.81,56l-.16-.15-.54-.51-.27-.24c-.27-.22-.55-.44-.85-.66l-.33-.22c-.23-.16-.48-.32-.73-.47l-.32-.2c-.37-.21-.74-.41-1.14-.61l-.42-.21.43-.2c7.16-3.26,7.72-11.28,7.72-13.66A16.9,16.9,0,0,0,66.93,36a19.7,19.7,0,0,0-2.3-6.25A19,19,0,0,0,63.56,28a20.75,20.75,0,0,1-3,2.71,16.18,16.18,0,0,1-3.68,2.06c.17.27.3.58.45.87a12,12,0,0,1,1.15,5.22c0,6.11-4.15,10.55-9.87,10.55-.37,0-.73,0-1.08,0a9.9,9.9,0,0,1-3.52-1l-.31-.14,0,0c-3.08-1.71-5-5.08-5-9.33a11.72,11.72,0,0,1,1.55-6l.06-.11a10.54,10.54,0,0,1,1.23-1.59,9.51,9.51,0,0,1,1-.9,9.78,9.78,0,0,1,6.13-2.07,10.18,10.18,0,0,1,3.26.55l.48.17h0c2.48-1.68,4.66-5.13,4.6-6.67h0a15.91,15.91,0,0,0-6.31-1.89c-.33,0-.68,0-1,0s-.67,0-1,0A19.94,19.94,0,0,0,40,22.13a17.35,17.35,0,0,0-3.83,2.45l-.56.5A18.25,18.25,0,0,0,30,38.85a20.21,20.21,0,0,0,2.42,10.06c3,5.34,8.65,8.41,16.2,8.41h.1c4.62,0,9.54,2.44,9.54,7.69,0,4.91-3.87,8.21-9.64,8.21-5.58,0-9.81-3.41-10-8H30c.11,9.5,7.74,16.13,18.62,16.13S67,74.79,67,65c0-3.81-1-6.73-3.25-9Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 125.51)"
  }, "Gateway")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVriLogo);
export default __webpack_public_path__ + "static/media/VriLogo.6db8d26f426cd136bcda84463bed2097.svg";
export { ForwardRef as ReactComponent };